import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  font-size: 24px;
  flex-direction: column;
`;